export type Language = 'de' | 'en';

export const LANGUAGES: { value: Language; label: string }[] = [
  { value: 'de', label: 'DE' },
  { value: 'en', label: 'EN' },
];

const translations = {
  de: {
    common: {
      save: 'Speichern',
      delete: 'Löschen',
      back: 'Zurück',
      cancel: 'Abbrechen',
      confirm: 'Bestätigen',
      yes: 'Ja',
      no: 'Nein',
      loading: 'Laden...',
      create: 'Erstellen',
      edit: 'Bearbeiten',
      search: 'Suchen...',
    },
    personEdit: {
      titleNew: 'Neue Person',
      titleEdit: 'Person bearbeiten',
      tabBasic: 'Stammdaten',
      tabContracts: 'Verträge',
      tabAccount: 'Konto',
      tabRights: 'Berechtigungen',
      tabMatches: 'Spieleinsätze',
      firstName: 'Vorname',
      lastName: 'Nachname',
      birthDate: 'Geburtsdatum',
      birthPlace: 'Geburtsort',
      nationality: 'Nationalität',
      street: 'Straße',
      city: 'Ort',
      zip: 'PLZ',
      email: 'E-Mail',
      phone: 'Telefon',
      emergencyPhone: 'Notfalltelefon',
      emergencyContact: 'Notfallkontakt',
      iban: 'IBAN',
      sv: 'SV-Nummer',
      notes: 'Notizen',
      oid: 'OID',
      parent: 'Erziehungsberechtigte',
      parentSearch: 'Person suchen...',
      oefbPlayer: 'ÖFB Spieler',
      playerSearch: 'Spieler suchen...',
      tags: 'Tags',
      confirmDeleteTitle: 'Person löschen',
      confirmDeleteMsg: 'Person wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
      validFirstName: 'Vorname erforderlich',
      validLastName: 'Nachname erforderlich',
      validEmail: 'Ungültige E-Mail-Adresse',
    },
    person: {
      title: 'Personen',
      filterName: 'Suche nach Name, E-Mail oder Telefon...',
      filterTags: 'Nach Tags filtern',
      excludeTags: 'Keine dieser Tags',
      selectTags: 'Tags auswählen',
      assignTagsBtn: 'Tags zuweisen an',
      persons: 'Person(en)',
      csvExport: 'CSV Export',
      accountReport: 'Kontoübersicht',
      summary: 'Zusammenfassung',
      colFirstName: 'Vorname',
      colLastName: 'Nachname',
      colBirthDate: 'Geburtsdatum',
      colTags: 'Tags',
      colContract: 'Aktiver Vertrag',
      colTraining: 'Training (Monat)',
      trainingTooltip: '{present} von {total} Trainings anwesend',
      colBalance: 'Kontostand',
      contractYes: 'Ja',
      contractNo: 'Nein',
      recordsPerPage: 'Einträge pro Seite',
      bulkTitle: 'Tags zuweisen',
      bulkDesc: 'Tags zuweisen an',
      bulkTagsLabel: 'Zuzuweisende Tags',
      cancel: 'Abbrechen',
      assign: 'Zuweisen',
    },
    nav: {
      home: 'Home',
      persons: 'Personen',
      booking: 'Buchhaltung',
      bookings: 'Buchungen',
      accountReport: 'Kontoübersicht',
      paymentsReport: 'Zahlungsübersicht',
      importPayments: 'Zahlungen importieren',
      calculateContracts: 'Verträge abrechnen',
      messages: 'Nachrichten',
      match: 'Spiele',
      matchOverview: 'Übersicht',
      matchStats: 'Statistik',
      loadMatchdata: 'Spieldaten laden',
      playerIdMatching: 'Spieler-IDs zuordnen',
      tags: 'Tags',
      contracts: 'Verträge',
      receipts: 'Belege',
      bookingTypes: 'Buchungstypen',
      training: 'Training',
      trainingEvents: 'Trainingseinheiten',
      invoices: 'Rechnungen',
      invoiceList: 'Rechnungen',
      articles: 'Artikel',
      inventory: 'Inventar',
      inventoryStock: 'Bestand',
      inventoryRentals: 'Verleih & Reservierungen',
      inventoryLocations: 'Lagerorte',
      inventoryKeys: 'Schlüssel',
      audit: 'Protokoll',
      restaurantStock: 'Bestand',
      invoiceSettings: 'Rechnungseinstellungen',
      admin: 'Administration',
      paymentAccounts: 'Zahlungskonten',
      myProfile: 'Mein Profil',
      myAccount: 'Mein Konto',
      myCalendar: 'Kalender-Abo',
      drafts: 'Entwürfe',
    },
    memberProfile: {
      title: 'Mein Profil',
      phone1: 'Telefon',
      phone2: 'Telefon 2',
      birthDate: 'Geburtsdatum',
      iban: 'IBAN',
      socialInsuranceNumber: 'Sozialversicherungsnummer',
      shirtSize: 'T-Shirt Größe',
      trouserSize: 'Hosengröße',
      shoeSize: 'Schuhgröße',
      emergencyTitle: 'Notfallkontakt',
      emergencyContact: 'Name / Beziehung',
      emergencyContactPlaceholder: 'z.B. Maria Muster (Mutter)',
      emergencyPhone: 'Notfall-Telefon',
      viewingAs: 'Ansicht für',
      myself: 'ich',
      saveSuccess: 'Gespeichert',
      saveSuccessDesc: 'Deine Daten wurden aktualisiert.',
      saveError: 'Fehler',
      saveErrorDesc: 'Daten konnten nicht gespeichert werden.',
    },
    memberAccount: {
      title: 'Mein Konto',
    },
    tAccount: {
      colDate: 'Datum',
      colType: 'Typ',
      colText: 'Text',
      colDebit: 'Soll',
      colCredit: 'Haben',
      sumLabel: 'Summe',
      receivable: 'Forderung',
      liability: 'Verbindlichkeit',
    },
    invoice: {
      title: 'Rechnungen',
      newInvoice: 'Neue Rechnung',
      colInvoiceNumber: 'Rechnungsnummer',
      colDate: 'Datum',
      colRecipient: 'Empfänger',
      colTotal: 'Zahlbetrag',
      colStatus: 'Status',
      statusOpen: 'Offen',
      statusFixed: 'Festgeschrieben',
      statusCancelled: 'Storniert',
      filterYear: 'Jahr',
      filterStatus: 'Status',
      filterAll: 'Alle',
      relatedCancellation: 'Storno',
      relatedOriginal: 'Original',
      confirmDeleteTitle: 'Rechnung löschen',
      confirmDeleteMsg: 'Soll diese Rechnung wirklich gelöscht werden?',
      confirmCancelTitle: 'Rechnung stornieren',
      confirmCancelMsg: 'Soll diese Rechnung wirklich storniert werden?',
      deleteSuccess: 'Rechnung gelöscht',
      deleteFailed: 'Löschen fehlgeschlagen',
      cancelAction: 'Stornieren',
      cancelSuccess: 'Rechnung storniert',
      cancelFailed: 'Stornierung fehlgeschlagen',
      fixSuccess: 'Rechnung festgeschrieben',
      fixFailed: 'Festschreiben fehlgeschlagen',
      loadFailed: 'Fehler beim Laden der Rechnungen',
      editTitle: 'Rechnung',
      newTitle: 'Neue Rechnung',
      draft: 'Entwurf',
      fixedBadge: 'Festgeschrieben',
      cancelledBadge: 'Storniert',
      cancellationBadge: 'Stornorechnung',
      relatedLabel: 'Zugehörige Rechnung',
      recipientSection: 'Empfänger',
      recipientOrg: 'Organisation / Verein',
      recipientName: 'Name (fett gedruckt)',
      recipientStreet: 'Straße',
      recipientCity: 'Ort',
      dateLabel: 'Rechnungsdatum',
      positionsSection: 'Positionen',
      articleCol: 'Artikel',
      descriptionCol: 'Beschreibung',
      quantityCol: 'Menge',
      unitPriceCol: 'Einzelpreis',
      sumCol: 'Summe',
      addPosition: 'Position hinzufügen',
      subtotal: 'Zwischensumme',
      vat: 'Umsatzsteuer',
      totalAmount: 'Zahlbetrag',
      textsSection: 'Texte',
      postTextLabel: 'Text nach den Positionen',
      vatTextLabel: 'MwSt.-Hinweis (im Footer)',
      pdfPrint: 'PDF drucken',
      saveSuccess: 'Rechnung gespeichert',
      createSuccess: 'Rechnung erstellt',
      saveFailed: 'Speichern fehlgeschlagen',
      loadError: 'Rechnung konnte nicht geladen werden',
      statusPaid: 'Bezahlt',
      statusUnpaid: 'Offen (festgeschrieben)',
      paidBadge: 'Bezahlt',
      colPaidDate: 'Bezahlt am',
      markPaid: 'Als bezahlt markieren',
      markUnpaid: 'Zahlung zurücksetzen',
      paidSuccess: 'Zahlungsstatus aktualisiert',
      paidFailed: 'Fehler beim Aktualisieren des Zahlungsstatus',
      paidDateLabel: 'Zahlungsdatum',
    },
    article: {
      title: 'Artikel',
      newArticle: 'Neuer Artikel',
      colName: 'Name',
      colDescription: 'Beschreibung',
      colUnitPrice: 'Einzelpreis',
      colCategory: 'Kategorie',
      confirmDeleteTitle: 'Artikel löschen',
      confirmDeleteMsg: 'Soll dieser Artikel wirklich gelöscht werden?',
      deleteSuccess: 'Artikel gelöscht',
      deleteFailed: 'Löschen fehlgeschlagen',
      notFound: 'Artikel nicht gefunden',
      nameLabel: 'Name',
      descriptionLabel: 'Beschreibung',
      descriptionPlaceholder: 'Standardtext für Rechnungspositionen',
      unitPriceLabel: 'Einzelpreis / Gastpreis (€)',
      memberPriceLabel: 'Mitgliederpreis (€, optional)',
      memberPriceDesc: 'Wird Vereinsmitgliedern statt dem Einzelpreis berechnet',
      restaurantArticleLabel: 'Restaurant-Artikel',
      restaurantArticleDesc: 'Wird auf der Restaurantkasse angezeigt',
      stockTrackedLabel: 'Bestand führen',
      deleteOrArchive: 'Löschen / Archivieren',
      archivedTitle: 'Archiviert',
      archivedMsg: 'Dieser Artikel ist archiviert und erscheint nicht an der Kasse, in der Artikelauswahl oder in den Listen. Bestehende Aufträge und Rechnungen bleiben erhalten.',
      archivedBadge: 'Archiviert',
      restore: 'Wiederherstellen',
      restored: 'Artikel wiederhergestellt',
      showArchived: 'Archivierte anzeigen',
      stockTrackedDesc: 'Verkäufe an der Kasse werden vom Bestand abgezogen. Anfangsbestand und Lieferungen unter „Inventar → Bestand“ buchen.',
      categoryLabel: 'Kategorie',
      categoryPlaceholder: 'Keine Kategorie',
      uncategorized: 'Sonstige',
      loadFailed: 'Fehler beim Laden der Artikel',
      saveSuccess: 'Artikel gespeichert',
      updateSuccess: 'Artikel aktualisiert',
      saveFailed: 'Speichern fehlgeschlagen',
    },
    invoiceSettings: {
      title: 'Rechnungseinstellungen',
      senderAddressLineLabel: 'Absender-Adresszeile (Kopfzeile)',
      footerLeftLabel: 'Footer links',
      footerCenterLabel: 'Footer Mitte',
      footerRightLabel: 'Footer rechts',
      saveSuccess: 'Einstellungen gespeichert',
      saveFailed: 'Speichern fehlgeschlagen',
      loadFailed: 'Fehler beim Laden',
    },
    home: {
      matchCalendar: 'Kalender',
      noMatches: 'Keine Termine in dieser Woche.',
      today: 'Heute',
      cancelled: 'Abgesagt',
      messages: 'Nachrichten',
      noMessages: 'Keine aktuellen Nachrichten.',
      minutes: 'Min.',
      oclock: 'Uhr',
      typeTraining: 'Training',
      typeMatch: 'Spiel',
      typeEvent: 'Event',
      from: 'Von',
      until: 'bis',
      birthdaysToday: 'Geburtstage heute',
      noBirthdays: 'Heute hat niemand Geburtstag.',
      yearsOld: 'Jahre',
      topScorers: 'Torschützenliste',
      noScorers: 'Noch keine Tore in dieser Saison.',
      topCards: 'Kartenkonto',
      noCards: 'Noch keine Karten in dieser Saison.',
      goals: 'Tore',
      topOwnGoals: 'Eigentore',
      noOwnGoals: 'Noch keine Eigentore in dieser Saison.',
    },
  },
  en: {
    common: {
      save: 'Save',
      delete: 'Delete',
      back: 'Back',
      cancel: 'Cancel',
      confirm: 'Confirm',
      yes: 'Yes',
      no: 'No',
      loading: 'Loading...',
      create: 'Create',
      edit: 'Edit',
      search: 'Search...',
    },
    personEdit: {
      titleNew: 'New Person',
      titleEdit: 'Edit Person',
      tabBasic: 'Basic',
      tabContracts: 'Contracts',
      tabAccount: 'Account',
      tabRights: 'Rights',
      tabMatches: 'Matches',
      firstName: 'First Name',
      lastName: 'Last Name',
      birthDate: 'Date of Birth',
      birthPlace: 'Place of Birth',
      nationality: 'Nationality',
      street: 'Street',
      city: 'City',
      zip: 'ZIP',
      email: 'Email',
      phone: 'Phone',
      emergencyPhone: 'Emergency Phone',
      emergencyContact: 'Emergency Contact',
      iban: 'IBAN',
      sv: 'Social Insurance No.',
      notes: 'Notes',
      oid: 'OID',
      parent: 'Parents / guardians',
      parentSearch: 'Search person...',
      oefbPlayer: 'OEFB Player',
      playerSearch: 'Search player...',
      tags: 'Tags',
      confirmDeleteTitle: 'Delete Person',
      confirmDeleteMsg: 'Are you sure you want to delete this person? This action cannot be undone.',
      validFirstName: 'First name is required',
      validLastName: 'Last name is required',
      validEmail: 'Invalid email address',
    },
    person: {
      title: 'Persons',
      filterName: 'Search by name, e-mail or phone...',
      filterTags: 'Filter by Tags',
      excludeTags: 'Exclude Tags',
      selectTags: 'Select tags',
      assignTagsBtn: 'Assign Tags to',
      persons: 'Person(s)',
      csvExport: 'CSV Export',
      accountReport: 'Account Report',
      summary: 'Summary',
      colFirstName: 'First Name',
      colLastName: 'Last Name',
      colBirthDate: 'Date of Birth',
      colTags: 'Tags',
      colContract: 'Valid Contract',
      colTraining: 'Training (month)',
      trainingTooltip: 'Present at {present} of {total} trainings',
      colBalance: 'Balance',
      contractYes: 'Yes',
      contractNo: 'No',
      recordsPerPage: 'Records per page',
      bulkTitle: 'Assign Tags',
      bulkDesc: 'Assign tags to',
      bulkTagsLabel: 'Tags to assign',
      cancel: 'Cancel',
      assign: 'Assign Tags',
    },
    nav: {
      home: 'Home',
      persons: 'Persons',
      booking: 'Accounting',
      bookings: 'Bookings',
      accountReport: 'Account Report',
      paymentsReport: 'Payments Report',
      importPayments: 'Import Payments',
      calculateContracts: 'Calculate Contracts',
      messages: 'Messages',
      match: 'Matches',
      matchOverview: 'Overview',
      matchStats: 'Statistics',
      loadMatchdata: 'Load Match Data',
      playerIdMatching: 'Player ID Matching',
      tags: 'Tags',
      contracts: 'Contracts',
      receipts: 'Receipts',
      bookingTypes: 'Booking Types',
      training: 'Training',
      trainingEvents: 'Training Sessions',
      invoices: 'Invoices',
      invoiceList: 'Invoices',
      articles: 'Articles',
      inventory: 'Inventory',
      inventoryStock: 'Stock',
      inventoryRentals: 'Rentals & reservations',
      inventoryLocations: 'Storage locations',
      inventoryKeys: 'Keys',
      audit: 'Audit log',
      restaurantStock: 'Stock',
      invoiceSettings: 'Invoice Settings',
      admin: 'Administration',
      paymentAccounts: 'Payment Accounts',
      myProfile: 'My Profile',
      myAccount: 'My Account',
      myCalendar: 'Calendar subscription',
      drafts: 'Drafts',
    },
    memberProfile: {
      title: 'My Profile',
      phone1: 'Phone',
      phone2: 'Phone 2',
      birthDate: 'Date of Birth',
      iban: 'IBAN',
      socialInsuranceNumber: 'Social Insurance No.',
      shirtSize: 'T-Shirt Size',
      trouserSize: 'Trouser Size',
      shoeSize: 'Shoe Size',
      emergencyTitle: 'Emergency contact',
      emergencyContact: 'Name / relationship',
      emergencyContactPlaceholder: 'e.g. Maria Muster (mother)',
      emergencyPhone: 'Emergency phone',
      viewingAs: 'Viewing as',
      myself: 'myself',
      saveSuccess: 'Saved',
      saveSuccessDesc: 'Your data has been updated.',
      saveError: 'Error',
      saveErrorDesc: 'Data could not be saved.',
    },
    memberAccount: {
      title: 'My Account',
    },
    tAccount: {
      colDate: 'Date',
      colType: 'Type',
      colText: 'Text',
      colDebit: 'Debit',
      colCredit: 'Credit',
      sumLabel: 'Total',
      receivable: 'Receivable',
      liability: 'Liability',
    },
    invoice: {
      title: 'Invoices',
      newInvoice: 'New Invoice',
      colInvoiceNumber: 'Invoice Number',
      colDate: 'Date',
      colRecipient: 'Recipient',
      colTotal: 'Total',
      colStatus: 'Status',
      statusOpen: 'Open',
      statusFixed: 'Fixed',
      statusCancelled: 'Cancelled',
      filterYear: 'Year',
      filterStatus: 'Status',
      filterAll: 'All',
      relatedCancellation: 'Cancellation',
      relatedOriginal: 'Original',
      confirmDeleteTitle: 'Delete Invoice',
      confirmDeleteMsg: 'Are you sure you want to delete this invoice?',
      confirmCancelTitle: 'Cancel Invoice',
      confirmCancelMsg: 'Are you sure you want to cancel this invoice?',
      deleteSuccess: 'Invoice deleted',
      deleteFailed: 'Delete failed',
      cancelAction: 'Cancel Invoice',
      cancelSuccess: 'Invoice cancelled',
      cancelFailed: 'Cancellation failed',
      fixSuccess: 'Invoice fixed',
      fixFailed: 'Fixing failed',
      loadFailed: 'Error loading invoices',
      editTitle: 'Invoice',
      newTitle: 'New Invoice',
      draft: 'Draft',
      fixedBadge: 'Fixed',
      cancelledBadge: 'Cancelled',
      cancellationBadge: 'Cancellation',
      relatedLabel: 'Related Invoice',
      recipientSection: 'Recipient',
      recipientOrg: 'Organisation / Club',
      recipientName: 'Name (printed bold)',
      recipientStreet: 'Street',
      recipientCity: 'City',
      dateLabel: 'Invoice Date',
      positionsSection: 'Positions',
      articleCol: 'Article',
      descriptionCol: 'Description',
      quantityCol: 'Qty',
      unitPriceCol: 'Unit Price',
      sumCol: 'Sum',
      addPosition: 'Add Position',
      subtotal: 'Subtotal',
      vat: 'VAT',
      totalAmount: 'Total',
      textsSection: 'Texts',
      postTextLabel: 'Text after positions',
      vatTextLabel: 'VAT note (in footer)',
      pdfPrint: 'Print PDF',
      saveSuccess: 'Invoice saved',
      createSuccess: 'Invoice created',
      saveFailed: 'Save failed',
      loadError: 'Could not load invoice',
      statusPaid: 'Paid',
      statusUnpaid: 'Unpaid (fixed)',
      paidBadge: 'Paid',
      colPaidDate: 'Paid on',
      markPaid: 'Mark as paid',
      markUnpaid: 'Reset payment',
      paidSuccess: 'Payment status updated',
      paidFailed: 'Error updating payment status',
      paidDateLabel: 'Payment date',
    },
    article: {
      title: 'Articles',
      newArticle: 'New Article',
      colName: 'Name',
      colDescription: 'Description',
      colUnitPrice: 'Unit Price',
      colCategory: 'Category',
      confirmDeleteTitle: 'Delete Article',
      confirmDeleteMsg: 'Are you sure you want to delete this article?',
      deleteSuccess: 'Article deleted',
      deleteFailed: 'Delete failed',
      notFound: 'Article not found',
      nameLabel: 'Name',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'Default text for invoice positions',
      unitPriceLabel: 'Unit Price / Guest Price (€)',
      memberPriceLabel: 'Member Price (€, optional)',
      memberPriceDesc: 'Charged to club members instead of the unit price',
      restaurantArticleLabel: 'Restaurant Article',
      restaurantArticleDesc: 'Displayed on the restaurant POS',
      stockTrackedLabel: 'Track stock',
      deleteOrArchive: 'Delete / archive',
      archivedTitle: 'Archived',
      archivedMsg: 'This article is archived and does not appear on the POS, in the article picker or in lists. Existing orders and invoices are kept.',
      archivedBadge: 'Archived',
      restore: 'Restore',
      restored: 'Article restored',
      showArchived: 'Show archived',
      stockTrackedDesc: 'POS sales reduce the stock. Book the initial amount and deliveries under "Inventory → Stock".',
      categoryLabel: 'Category',
      categoryPlaceholder: 'No category',
      uncategorized: 'Other',
      loadFailed: 'Error loading articles',
      saveSuccess: 'Article saved',
      updateSuccess: 'Article updated',
      saveFailed: 'Save failed',
    },
    invoiceSettings: {
      title: 'Invoice Settings',
      senderAddressLineLabel: 'Sender address line (header)',
      footerLeftLabel: 'Footer left',
      footerCenterLabel: 'Footer center',
      footerRightLabel: 'Footer right',
      saveSuccess: 'Settings saved',
      saveFailed: 'Save failed',
      loadFailed: 'Error loading settings',
    },
    home: {
      matchCalendar: 'Calendar',
      noMatches: 'No events this week.',
      today: 'Today',
      cancelled: 'Cancelled',
      messages: 'Messages',
      noMessages: 'No current messages.',
      minutes: 'min.',
      oclock: '',
      typeTraining: 'Training',
      typeMatch: 'Match',
      typeEvent: 'Event',
      from: 'From',
      until: 'until',
      birthdaysToday: 'Birthdays Today',
      noBirthdays: 'Nobody has a birthday today.',
      yearsOld: 'years',
      topScorers: 'Top Goalscorers',
      noScorers: 'No goals scored this season yet.',
      topCards: 'Top Card Receivers',
      noCards: 'No cards this season yet.',
      goals: 'goals',
      topOwnGoals: 'Own Goals',
      noOwnGoals: 'No own goals this season yet.',
    },
  },
} as const;

export type CommonTranslations = { [K in keyof typeof translations.de.common]: string };
export type PersonEditTranslations = { [K in keyof typeof translations.de.personEdit]: string };
export type NavTranslations = { [K in keyof typeof translations.de.nav]: string };
export type PersonTranslations = { [K in keyof typeof translations.de.person]: string };
export type InvoiceTranslations = { [K in keyof typeof translations.de.invoice]: string };
export type ArticleTranslations = { [K in keyof typeof translations.de.article]: string };
export type InvoiceSettingsTranslations = { [K in keyof typeof translations.de.invoiceSettings]: string };
export type MemberProfileTranslations = { [K in keyof typeof translations.de.memberProfile]: string };
export type MemberAccountTranslations = { [K in keyof typeof translations.de.memberAccount]: string };
export type TAccountTranslations = { [K in keyof typeof translations.de.tAccount]: string };
export type HomeTranslations = { [K in keyof typeof translations.de.home]: string };

export default translations;
